import { observable } from 'mobx';

export type TransportElementAttachFileResponseArgs = {
  id: number;
  trip_id: number;
  upload_file_name: string;
  content_type: string;
  file_path: string;
  traveler_information_id: string | null;
  transport_element_id?: number;
};

export type TransportElementAttachFileArgs = {
  id: number;
  tripId: number;
  uploadFileName: string;
  contentType: string;
  filePath: string;
  travelerInformationId: string | null;
  transportElementId?: number;
};

export const convertTransportElementAttachFileResponseToArgs = (
  response: TransportElementAttachFileResponseArgs
) => {
  const args: TransportElementAttachFileArgs = {
    id: response.id,
    tripId: response.trip_id,
    uploadFileName: response.upload_file_name,
    contentType: response.content_type,
    filePath: response.file_path,
    travelerInformationId: response.traveler_information_id,
    transportElementId: response.transport_element_id
  };
  return args;
};

export default class TransportElementAttachFile {
  @observable id: number;
  @observable tripId: number;
  @observable uploadFileName: string;
  @observable contentType: string;
  @observable filePath: string;
  @observable travelerInformationId: string | null;
  @observable transportElementId?: number;

  constructor(args: TransportElementAttachFileArgs) {
    this.id = args.id;
    this.tripId = args.tripId;
    this.uploadFileName = args.uploadFileName;
    this.contentType = args.contentType;
    this.filePath = args.filePath;
    this.travelerInformationId = args.travelerInformationId;
    this.transportElementId = args.transportElementId;
  }

  get updateParams() {
    return {
      trip_id: this.tripId,
      traveler_information_id: this.travelerInformationId,
      upload_file_name: this.uploadFileName,
      content_type: this.contentType,
      file_path: this.filePath
    };
  }
}
